import { render, staticRenderFns } from "./HireRejectAction.vue?vue&type=template&id=1f63673a"
import script from "./HireRejectAction.vue?vue&type=script&lang=js"
export * from "./HireRejectAction.vue?vue&type=script&lang=js"
import style0 from "./HireRejectAction.vue?vue&type=style&index=0&id=1f63673a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports